export default "__VITE_ASSET__CzFP9ABZ__"